import { Chip } from "@mui/material";

export const StatusChip = ({
  status,
}: {
  status: { label: string; color: string };
}) => (
  <Chip
    label={status.label}
    size="small"
    sx={{
      backgroundColor: status.color,
      color: "text.onbrand",
      fontWeight: "medium",
      "& .MuiChip-label": { fontSize: "0.65rem" },
    }}
  />
);
